<template>
    <div
            class="modal fade"
            id="sys_repairdispatch_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">派单</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <div class="form-group">
                        <label class="col-sm-2 control-label">执行人:</label>
                        <div class="col-sm-4">
                            <select
                                    name
                                    class="dispatchchosen-select"
                                    style="width: 294px;"
                                    aria-placeholder="请选择执行人"
                            >
                                <option value>请选择执行人</option>
                                <option
                                        v-for="(item,index) in employments"
                                        :key="index"
                                        :value="item.id"
                                >{{item.username}}
                                </option>
                            </select>
                        </div>
                        <label class="col-sm-2 control-label">初步反馈:</label>
                        <div class="col-sm-4">
                            <input type="text" class="form-control" v-model="submitData.feedback"/>
                        </div>
                    </div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" class="btn btn-primary" @click="submit">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        org_id: '', // 公司id
        employments: [], // 成员列表
        submitData: {
          executor_id: '',
          feedback: '',
          status: 20
        }
      }
    },
    props: ['infoTaskid'],
    mounted: function () {
      var self = this
      var org_id = JSON.parse(localStorage.getItem('companyInfo')).id
      self.org_id = org_id

      $('.dispatchchosen-select')
        .chosen({
          disable_search_threshold: 10,
          disable_search: true,
          width: '100%'
        })
        .change(function () {
          self.submitData.executor_id = $('.dispatchchosen-select').val()
        })
    },
    methods: {
      initFunc: function () {
        // 获取组织下成员列表
        var self = this
        self.global.axiosGet(
          self,
          'organizations/' + self.org_id + '/employments/',
          function (res) {
            console.log('获取组织下成员列表', res)
            self.employments = res
            setTimeout(function () {
              $('.dispatchchosen-select').trigger('chosen:updated')
            }, 400)
          }
        )
      },
      // 提交
      submit: function () {
        var self = this
        var putData = self.submitData
        console.log('putData', putData)
        self.global.axiosPut(
          self,
          'tasks/' + self.infoTaskid + '/',
          putData,
          function (res) {
            console.log('更新任务进度', res)
            if (res.status == 'status') {
              alert('提交成功')
            } else {
              alert('提交失败')
            }
          },
          function () {
            alert('提交失败')
          }
        )
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/repairtask/repairdispatch.vue